module.exports = __webpack_public_path__ + "b0e25b9ec0d22791e7d7531267d4297f.jpg";